import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RevenueFormComponent } from './revenue-form/revenue-form.component';
import {MatDialogModule} from '@angular/material/dialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatRippleModule} from '@angular/material/core';
import {NgxMatDatetimePickerModule} from '@angular-material-components/datetime-picker';
import {CurrencyInputModule} from "../currency-input/currency-input.module";
import {RouterModule} from "@angular/router";
import {MatTabsModule} from "@angular/material/tabs";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {SharedModule} from "../../shared/shared.module";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";



@NgModule({
  declarations: [RevenueFormComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatRippleModule,
        NgxMatDatetimePickerModule,
        CurrencyInputModule,
        RouterModule,
        MatTabsModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatTabsModule,
        SharedModule
    ]
})
export class RevenueModule { }
